// お問い合せフォームのサブクエスチョン表示制御
document.addEventListener('DOMContentLoaded', () => {
  const ids = {
    '会社設立について': 'setsuritsu',
    '初期指導・年間サポートについて': 'support',
    '相続税について': 'souzoku',
    '確定申告について': 'kakutei',
    'セミナー・説明会のお申し込み': 'seminar',
  };

  const matters = document.querySelectorAll('.subquestions');
  matters.forEach((m) => (m.style.display = 'none'));

  const showSubquestions = (val) => {
    const id = ids[val];
    matters.forEach((m) => {
      if (id && m.id === 'matter-' + id) {
        m.style.display = '';
      } else {
        m.style.display = 'none';
      }
    });
  };

  document.querySelectorAll('.matter input[type=radio]').forEach((radio) => {
    radio.addEventListener('change', (e) => showSubquestions(e.target.value));
  });

  window.addEventListener('load', () => {
    const params = new URLSearchParams(location.search);

    const matter = params.get('matter');
    if (matter) {
      const radio = document.querySelector(`.matter input[type=radio][value="${matter}"]`);
      if (radio) {
        radio.checked = true;
        showSubquestions(matter);
      }
    }

    const seminarName = params.get('seminarName');
    if (seminarName) {
      const input = document.querySelector('input#seminarName');
      if (input) input.value = seminarName;
    }
  });
});
